import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';

import {
  SubmitCommissioningInfoInput,
  SubmitCommissioningInfoMutation,
} from '@/gql/graphql';

const SubmitCommissioningInfo = graphql(`
  mutation SubmitCommissioningInfo($input: SubmitCommissioningInfoInput!) {
    submitCommissioningInfo(input: $input) {
      __typename
      ... on CommissioningInfoRejected {
        message
      }
    }
  }
`);

const useSubmitCommissioningInfo = (
  options?: UseMutationOptions<
    SubmitCommissioningInfoMutation['submitCommissioningInfo'],
    unknown,
    SubmitCommissioningInfoInput
  >
) => {
  return useMutation({
    mutationFn: async (input) => {
      const response = await gqlClient.request(SubmitCommissioningInfo, {
        input,
      });

      return response.submitCommissioningInfo;
    },
    ...options,
  });
};

export default useSubmitCommissioningInfo;
